import { useState, useContext } from "react";
import parseFormula from "../parseformula";
import { ChemicalFormulaContext } from "../contexts/formulaprovider";
import { SLabelFormula, SInputFormula, SButtonCalculate } from "./styled";

export const InputField = () => {
  const [formula, setFormula] = useState("");
  const { elements, setElements } = useContext(ChemicalFormulaContext);

  //  console.log(elements);
  const onChange = (e) => {
    setFormula(e.target.value);
  };
  const onClick = () => {
    setElements(parseFormula(formula));
  };

  return (
    <>
      <SLabelFormula htmlFor="formula">化学式</SLabelFormula>
      <SInputFormula type="text" value={formula} onChange={onChange} id="formula" />
      <SButtonCalculate onClick={onClick} disabled={formula === ""}>
        計算
      </SButtonCalculate>
      <br />
      {elements === null && <span style={{ color: "red" }}>化学式が正しくありません</span>}
    </>
  );
};
